<mat-card appearance="outlined">

    <mat-card-header>
        <mat-card-title>Standards Reference</mat-card-title>
    </mat-card-header>


    <mat-card-content>

        <div class="mt1">

            <form (formValid)="formValid.set($event)"
                  (formDirty)="formDirty.set($event)">

                <div>
                    <mat-form-field class="w-full">
                        <mat-label>select standard</mat-label>
                        <mat-select [formField]="standardsReferenceForm.standardGuid">
                            @for (standard of standards(); track standard.value) {
                            <mat-option [value]="standard.value">{{standard.label}}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                </div>

                @if (standardsReferenceForm().dirty()) {

                <div>
                    <mat-form-field class="w-full">
                        <mat-label>select table</mat-label>
                        <mat-select [formField]="standardsReferenceForm.tableGuid">
                            @for (table of tables(); track table.value) {
                            <mat-option [value]="table.value">{{table.label}}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                </div>
                }

                <div [innerHTML]="tableData().html" class="v-standard-ref"></div>


            </form>

        </div>

    </mat-card-content>

</mat-card>

@if (tablesResource.isLoading() || tableDataResource.isLoading()) {
<div class="spinner-center spinner-overlay">
    <mat-spinner test-id="spinner"></mat-spinner>
</div>   }
